export const enum ImportStatus {
    ReadingAndFillingData = 1,
    CheckingPermissions = 2,
    SavingData = 3,
    Complete = 4,
    Error = 5,
}
